var L = D;
function D(t, e, u) {
  var n = null, r = null, i = function() {
    n && (clearTimeout(n), r = null, n = null);
  }, o = function() {
    var c = r;
    i(), c && c();
  }, s = function() {
    if (!e)
      return t.apply(this, arguments);
    var c = this, E = arguments, a = u && !n;
    if (i(), r = function() {
      t.apply(c, E);
    }, n = setTimeout(function() {
      if (n = null, !a) {
        var p = r;
        return r = null, p();
      }
    }, e), a)
      return r();
  };
  return s.cancel = i, s.flush = o, s;
}
var F = w;
function w(t, e, u) {
  var n = null, r = null, i = u && u.leading, o = u && u.trailing;
  i == null && (i = !0), o == null && (o = !i), i == !0 && (o = !1);
  var s = function() {
    n && (clearTimeout(n), n = null);
  }, c = function() {
    var a = r;
    s(), a && a();
  }, E = function() {
    var a = i && !n, p = this, A = arguments;
    if (r = function() {
      return t.apply(p, A);
    }, n || (n = setTimeout(function() {
      if (n = null, o)
        return r();
    }, e)), a)
      return a = !1, r();
  };
  return E.cancel = s, E.flush = c, E;
}
function J(t) {
  return new URL(t.toString(), document.baseURI);
}
function Q(t) {
  return `${t.pathname}${t.search}`;
}
function Z(t, { target: e, cancelable: u, detail: n } = {}) {
  const r = new CustomEvent(t, {
    cancelable: u,
    bubbles: !0,
    detail: n
  });
  return e && e.isConnected ? e.dispatchEvent(r) : document.documentElement.dispatchEvent(r), r;
}
const d = 500;
function tt(t, e, u) {
  let n = b.get(t);
  n || u != 0 && (n = L(e, u ?? d), b.set(t, n)), (n ?? e)();
}
const b = /* @__PURE__ */ new WeakMap();
function et(t) {
  var e;
  (e = b.get(t)) == null || e.cancel();
}
function nt(t, e, u) {
  let n = T.get(t);
  n || u != 0 && (n = F(e, u ?? d), T.set(t, n)), (n ?? e)();
}
const T = /* @__PURE__ */ new WeakMap();
function ut(t) {
  var e;
  (e = T.get(t)) == null || e.cancel();
}
function rt(t, e = 0) {
  return t ? parseInt(t) : e;
}
function f(t) {
  return N(t) && t.nodeType == Node.ELEMENT_NODE;
}
function it(t) {
  return f(t) && "style" in t;
}
function h(t) {
  return f(t) && t.tagName == "BUTTON";
}
function ct(t) {
  return f(t) && t.tagName == "A";
}
function lt(t) {
  return f(t) && t.tagName == "LINK";
}
function ot(t) {
  return f(t) && t.tagName == "FORM";
}
function st(t) {
  return h(t) || l(t);
}
function l(t) {
  return f(t) && t.tagName == "INPUT";
}
function S(t) {
  return f(t) && ["INPUT", "TEXTAREA", "SELECT"].includes(t.tagName);
}
function g(t) {
  return f(t) && t.tagName == "TEXTAREA";
}
function x(t) {
  return f(t) && t.tagName == "SELECT";
}
function ft(t) {
  return f(t) && t.tagName == "OPTION";
}
function M(t) {
  return l(t) && q(t.type);
}
function O(t) {
  return l(t) && t.type == "number";
}
function P(t) {
  return l(t) && t.type == "checkbox";
}
function R(t) {
  return l(t) && t.type == "radio";
}
function C(t) {
  return l(t) && t.type == "range";
}
function U(t) {
  return l(t) && t.type == "color";
}
function k(t) {
  return l(t) && t.type == "file";
}
function _(t) {
  return l(t) && t.type == "hidden";
}
function G(t) {
  return g(t) || l(t) && Y(t.type);
}
function v(t) {
  return g(t) || l(t) && z(t.type);
}
function H(t) {
  return x(t) || l(t) && j(t.type);
}
function at(t) {
  return N(t) && (t.nodeType == Node.TEXT_NODE || t.nodeType == Node.ELEMENT_NODE);
}
function N(t) {
  return !!t && "nodeType" in t;
}
function Et(t) {
  return t.ownerDocument.activeElement == t;
}
function $(t) {
  if ("focus" in t && typeof t.focus == "function" && (t.focus(), v(t)))
    try {
      t.setSelectionRange(t.value.length, t.value.length);
    } catch {
    }
}
function pt(t, e) {
  const u = t.ownerDocument.activeElement;
  if (u && (t == u || t.contains(u))) {
    const n = W(t, u, e);
    n && $(n);
  }
}
function bt(t) {
  return new DOMParser().parseFromString(t, "text/html");
}
function Tt(t, e) {
  const u = e.createElement("template");
  u.innerHTML = t;
  const n = u.content;
  return n.normalize(), n;
}
function mt() {
  return new Promise((t) => {
    document.readyState == "loading" ? document.addEventListener("DOMContentLoaded", () => t(), { once: !0 }) : t();
  });
}
function dt() {
  return new Promise((t) => requestAnimationFrame(() => t()));
}
class B extends Error {
}
function gt(t, e) {
  return new Promise((u, n) => {
    const r = setTimeout(u, t);
    e == null || e.addEventListener(
      "abort",
      () => {
        clearTimeout(r), n(new B("Aborted"));
      },
      { once: !0 }
    );
  });
}
function xt(t, e) {
  return t.reduce((u, n) => {
    const r = e(n), i = u.get(r);
    return i ? i.push(n) : u.set(r, [n]), u;
  }, /* @__PURE__ */ new Map());
}
function vt(t, e) {
  return t.reduce(
    (u, n) => (e(n) ? u[0].push(n) : u[1].push(n), u),
    [[], []]
  );
}
function W(t, e, u) {
  var c;
  const n = u == null ? void 0 : u.focusDirectionAttribute, r = u == null ? void 0 : u.focusGroupAttribute, i = n ? (c = t.closest(`[${n}]`)) == null ? void 0 : c.getAttribute(n) : "prev", o = r ? t.closest(`[${r}]`) : null;
  return (o ? m(
    o,
    t,
    e,
    i == "next" ? "next" : "prev"
  ) : null) || m(
    t.ownerDocument.body,
    t,
    e,
    i == "next" ? "next" : "prev"
  );
}
function m(t, e, u, n = "prev") {
  const r = X(t, e, u), i = r.indexOf(u);
  if (r.length < 2)
    return null;
  const o = r.length - 1, s = i != 0 ? i - 1 : i + 1, c = i != o ? i + 1 : i - 1;
  return n == "prev" ? r.at(s) ?? r.at(c) ?? null : r.at(c) ?? r.at(s) ?? null;
}
function X(t, e, u) {
  return [
    ...t.querySelectorAll(
      'a[href], button:not(:disabled), input:not(:disabled), textarea:not(:disabled), select:not(:disabled), details, [tabindex]:not([tabindex="-1"])'
    )
  ].filter(
    (n) => n == u || !n.closest("[aria-hidden], [hidden]") && !e.contains(n)
  );
}
const I = ["text", "search", "url", "tel", "password", "email"];
function Y(t) {
  return I.includes(t);
}
const y = ["date", "datetime-local", "month", "week", "time"];
function q(t) {
  return y.includes(t);
}
const K = [...I, ...y, "number"];
function z(t) {
  return K.includes(t);
}
const V = ["checkbox", "radio", "range", "file", "color"];
function j(t) {
  return V.includes(t);
}
function Nt(t, e, u) {
  var n, r, i;
  S(t) && !(u != null && u.disabled) && t.disabled || (v(t) ? e.text && G(t) ? e.text(t) : e.date && M(t) ? e.date(t) : e.number && O(t) ? e.number(t) : (n = e.inputable) == null || n.call(e, t) : H(t) ? e.select && x(t) ? e.select(t) : e.checkbox && P(t) ? e.checkbox(t) : e.radio && R(t) ? e.radio(t) : e.range && C(t) ? e.range(t) : e.file && k(t) ? e.file(t) : e.color && U(t) ? e.color(t) : (r = e.changeable) == null || r.call(e, t) : _(t) && ((i = e.hidden) == null || i.call(e, t)));
}
export {
  B as AbortError,
  et as cancelDebounce,
  ut as cancelThrottle,
  tt as debounce,
  Z as dispatch,
  mt as domReady,
  J as expandURL,
  $ as focusElement,
  pt as focusNextElement,
  xt as groupBy,
  ct as isAnchorElement,
  h as isButtonElement,
  H as isChangeableElement,
  P as isCheckboxInputElement,
  U as isColorInputElement,
  M as isDateInputElement,
  f as isElement,
  at as isElementOrText,
  k as isFileInputElement,
  Et as isFocused,
  ot as isFormElement,
  S as isFormInputElement,
  ft as isFormOptionElement,
  it as isHTMLElement,
  _ as isHiddenInputElement,
  l as isInputElement,
  v as isInputableElement,
  lt as isLinkElement,
  O as isNumberInputElement,
  R as isRadioInputElement,
  C as isRangeInputElement,
  x as isSelectElement,
  st as isSubmitterElement,
  g as isTextAreaElement,
  G as isTextInputElement,
  Nt as matchInputElement,
  dt as nextAnimationFrame,
  bt as parseHTMLDocument,
  Tt as parseHTMLFragment,
  rt as parseIntWithDefault,
  vt as partition,
  Q as relativeURL,
  nt as throttle,
  gt as wait
};
